import styled from "styled-components"

import { minWidth, maxWidth, when, unless } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import BaseCard from "../base"

export const Card = styled.div`
  margin-bottom: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  ${minWidth.tabletLow`
    padding: 0 1rem;
  `}

  ${minWidth.tablet`
    padding: 0 2rem;
  `}

  ${minWidth.desktop`
    padding: 0;
  `}

  ${minWidth.desktopXL`
    padding: 0 4rem;
  `}
`

export const Container = styled.div`
  width: 24.5rem;

  ${maxWidth.hamburgerLarge`
    width: 20.8rem;
  `}

  ${maxWidth.tablet`
    width: 18.8rem;
  `}

  ${maxWidth.mobile`
    width: 15.8rem;
  `}

  ${maxWidth.mobileM`
    width: 13.7rem;
  `}

  figure {
    width: 100%;
    margin: 0;
  }

  h4 {
    font-weight: 500;
    line-height: 1.35;

    ${maxWidth.mobile`
      margin-top: 1rem;
    `}
  }

  p {
    margin-top: 0;
    line-height: 1.35;

    ${maxWidth.mobile`
      margin-top: 0.5rem;
      line-height: 1.35;
    `}
  }
`

export const SquareCard = styled(BaseCard)`
  /* image */
  > a > div {
    background-color: #efeee9;
  }

  /* headline */
  > div > a > h3 {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.4rem;
    text-transform: uppercase;

    ${minWidth.tablet`
      font-size: 1.8rem;
      line-height: 2.2rem;
    `}
  }
`

export const Image = styled(CloudinaryImage)`
  padding-bottom: 100%;
  margin-bottom: 2.6rem;

  img {
    width: 100%;
    height: unset;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    background-color: #f3f3f3;

    ${maxWidth.mobile`
      border-radius: 50%;
    `}
  }
`

export const Name = styled.h4`
  margin: 0.8rem 0;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.35;
  color: black;

  ${unless("isHomePage")`
    text-align: center;
  `}

  ${maxWidth.mobile`
    font-size: 1.6rem;
  `}

  span {
    display: block;
    font-size: 1.4rem;

    ${maxWidth.mobile`
      font-size: 1rem;
      margin-top: 0;
    `}
  }
`

export const Credentials = styled.h4`
  min-height: 3rem;
  max-width: 14.9rem;
  padding-right: 1.6rem;
  margin-top: 0.8rem;
  margin-bottom: 2rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.35;
  color: #12233f;
  text-transform: uppercase;
  letter-spacing: 0.01rem;

  ${unless("isHomePage")`
    text-align: center;
  `}

  ${maxWidth.mobile`
    font-size: 1rem;
    margin-bottom: 1rem;
  `}
`

export const Description = styled.div`
  ${when("isHomePage")`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17.772rem;
    height: 2.6rem;
    gap: 0.8rem;
    border-radius: 0.4rem;
    background: #2260b2;
    color: black;

    ${maxWidth.tablet`
      width: 14.772rem;
    `}

    ${maxWidth.mobile`
      width: 13.7rem;
    `}

    p {
      color: #fff;
      font-size: 1.2rem;
      font-weight: 500;
      letter-spacing: 0.05rem;
      text-transform: uppercase;
      margin: 0;

      ${maxWidth.tablet`
        font-size: 1rem;
      `}

      ${maxWidth.mobile`
        font-size: 0.9rem;
      `}
    }
  `}

  ${unless("isHomePage")`
    display: -webkit-box;
    font-size: 1.2rem;
    line-height: 1.872rem;
    text-align: center;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `}
`
